import { MasterBarcodeEntry, MasterUPCData } from '../types';

export type MasterLabelTrailingTile =
  | {
      kind: 'loading';
      key: string;
      query: string;
    }
  | {
      kind: 'no-results';
      key: string;
      query: string;
    };

export function countMasterLabelBarcodeRows(upc: MasterUPCData): number {
  return (
    (upc.barcodeSummary?.primaryUpcs.length ?? 0) +
    (upc.barcodeSummary?.alternateUpcs.length ?? 0) +
    (upc.barcodeSummary?.casePacks.length ?? 0)
  );
}

export function countMasterLabelCrops(upc: MasterUPCData): number {
  return (
    upc.designs.reduce((total, design) => total + design.crops.length, 0) +
    (upc.pendingCrops?.length ?? 0) +
    upc.unassignedCrops.length +
    upc.cartonCrops.length +
    (upc.inactiveCrops?.length ?? 0)
  );
}

export function isDisplayableMasterLabelColumn(upc: MasterUPCData): boolean {
  if (isBarcodeOnlyMasterLabelColumn(upc)) {
    return countMasterLabelCrops(upc) > 0 || upc.designs.length > 0;
  }
  return countMasterLabelBarcodeRows(upc) > 0 || countMasterLabelCrops(upc) > 0;
}

export function getNewDesignBarcodeCandidates(upc: MasterUPCData): MasterBarcodeEntry[] {
  const entriesByBarcode = new Map(
    [...(upc.barcodeSummary?.primaryUpcs ?? []), ...(upc.barcodeSummary?.alternateUpcs ?? [])].map(
      (entry) => [entry.upc.trim(), entry] as const
    )
  );
  return (upc.newDesignNormalizedBarcodes ?? []).map(
    (normalizedBarcode) =>
      entriesByBarcode.get(normalizedBarcode) ?? {
        upc: normalizedBarcode,
        provenance: ['Lookup'],
        storeDetails: [],
      }
  );
}

export function isBarcodeOnlyMasterLabelColumn(upc: MasterUPCData): boolean {
  return upc.lookupKind === 'normalized_barcode' && !upc.actualItemNumber;
}
